var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergeMultipleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.166 9.14825V8.24992C20.166 3.66659 18.3327 1.83325 13.7493 1.83325H8.24935C3.66602 1.83325 1.83268 3.66659 1.83268 8.24992V13.7499C1.83268 18.3333 3.66602 20.1666 8.24935 20.1666H9.16602",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00095 7.90725H10.8155",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9082 10.8145V5",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.916 14.8042V17.2792C11.916 19.3417 12.741 20.1667 14.8035 20.1667H17.2785C19.341 20.1667 20.166 19.3417 20.166 17.2792V14.8042C20.166 12.7417 19.341 11.9167 17.2785 11.9167H14.8035C12.741 11.9167 11.916 12.7417 11.916 14.8042Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeMultipleIcon);
export default __webpack_public_path__ + "static/media/merge_multiple_icon.cbd910d790558faffa48619d56e5cd66.svg";
export { ForwardRef as ReactComponent };